import React, { Component, createElement, Fragment } from 'react';
import builder, { ComponentsManager, EntitiesManager, actions } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { Button } from '@comall-backend-builder/components-basis';
import { Modal as AntModal, message as AntMessage } from 'antd';
import { isEmpty } from 'lodash';

interface AttributeOptionSelectorProps {
    componentId: string;
    onSelect: (attribute: string, options: string[]) => void;
}

interface AttributeOptionSelectorStates {
    selectedAttributeKey: string;
    selecteOptionKeys: string[];
    visible: boolean;
    step: 'attribute' | 'option';
}

export class attributeOptionSelector extends Component<
    AttributeOptionSelectorProps,
    AttributeOptionSelectorStates
> {
    private attributeEntity: Entity;
    private optionEntity: Entity;

    static defaultProps = {
        onSelect: () => {},
    };

    constructor(props: AttributeOptionSelectorProps) {
        super(props);
        this.state = {
            selectedAttributeKey: '',
            selecteOptionKeys: [],
            visible: false,
            step: 'attribute',
        };
        this.attributeEntity = new (EntitiesManager.get('attribute'))({});
        this.optionEntity = new (EntitiesManager.get('attributeOption'))({});

        this.onShow = this.onShow.bind(this);
        this.onHide = this.onHide.bind(this);
        this.onSave = this.onSave.bind(this);
        this.handleModelTitle = this.handleModelTitle.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        // this.handleRender = this.handleRender.bind(this);
    }

    onShow() {
        this.setState({ visible: true }, () => {
            // 需要重新获取数据
            this.attributeEntity.search({
                page: 1,
                perPage: 10,
            });
        });
    }

    onHide() {
        // 关闭窗口，需要清空已选择的数据
        const { componentId } = this.props;
        builder
            .getStore()
            .dispatch(actions.tableRowSelectionChangeAction(componentId + '-Attribute', []));
        builder
            .getStore()
            .dispatch(actions.tableRowSelectionChangeAction(componentId + '-Option', []));

        // 关闭窗口，需要清空搜索词
        builder
            .getStore()
            .dispatch(actions.filtersChangeAction(this.attributeEntity, { arrtCode: '' }));
        builder
            .getStore()
            .dispatch(actions.filtersChangeAction(this.optionEntity, { optionCode: '' }));

        this.setState({
            visible: false,
            step: 'attribute',
        });
    }

    onSave() {
        const { step, selecteOptionKeys, selectedAttributeKey } = this.state;
        const { onSelect } = this.props;
        if (step === 'attribute' && isEmpty(selectedAttributeKey)) {
            AntMessage.warning('请先选择属性');
            return;
        }
        if (step === 'option' && isEmpty(selecteOptionKeys)) {
            AntMessage.warning('请先选择属性');
            return;
        }
        if (step === 'attribute') {
            this.optionEntity.search({});
            this.setState({ step: 'option' });
            return;
        }

        this.onHide();
        onSelect(selectedAttributeKey, selecteOptionKeys);
        this.setState({ step: 'attribute' });
    }

    renderAttributeFilter() {
        const { componentId } = this.props;
        const filterProps = {
            entity: this.attributeEntity,
            componentId: componentId + '-Attribute',
            labelCol: 6,
            fields: [
                {
                    property: 'attrName',
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
        };
        return createElement(ComponentsManager.get('FilterFormPlus'), filterProps);
    }
    renderAttributeTable() {
        const { componentId } = this.props;
        const tableProps = {
            entity: this.attributeEntity,
            componentId: componentId + '-Attribute',
            rowKey: 'attrCode',
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            columns: [
                {
                    property: 'attrCode',
                },
                {
                    property: 'attrName',
                },
            ],
            rowSelection: {
                columnTitle: '选择',
                type: 'radio',
                onChange: (selectedKeys: string[]) => {
                    this.setState({
                        selectedAttributeKey: selectedKeys[0],
                    });
                    this.optionEntity.filtersChange({ attrCode: selectedKeys } as any);
                },
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }
    renderOptionFilter() {
        const { componentId } = this.props;
        const filterProps = {
            entity: this.optionEntity,
            componentId: componentId + '-Option',
            labelCol: 6,
            fields: [
                {
                    property: 'optionName',
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
        };
        return createElement(ComponentsManager.get('FilterFormPlus'), filterProps);
    }
    renderOptionTable() {
        const { componentId } = this.props;
        const tableProps = {
            entity: this.optionEntity,
            componentId: componentId + '-Option',
            rowKey: 'optionCode',
            // loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '20', '50', '100', '300'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            columns: [
                {
                    property: 'optionCode',
                },
                {
                    property: 'optionName',
                },
            ],
            rowSelection: {
                columnTitle: '选择',
                onChange: (selectedKeys: string[]) => {
                    this.setState({
                        selecteOptionKeys: selectedKeys,
                    });
                },
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    handleModelTitle() {
        const { step } = this.state;
        switch (step) {
            case 'attribute':
                return '请选择属性';
            case 'option':
                return '请选择属性值';
        }
    }
    handleNextStep() {
        const { step } = this.state;
        switch (step) {
            case 'attribute':
                return '下一步';
            case 'option':
                return '添加';
        }
    }
    render() {
        const { visible, step } = this.state;
        return (
            <Fragment>
                <Button type="primary" onClick={this.onShow} style={{ marginBottom: 20 }}>
                    关联属性
                </Button>
                <AntModal
                    visible={visible}
                    title={this.handleModelTitle()}
                    okText={this.handleNextStep()}
                    cancelText="取消"
                    onCancel={this.onHide}
                    onOk={this.onSave}
                    mask
                    centered
                    width={1000}
                >
                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        {/* 这里这么写是因为如果做切换渲染会遇到一个运行时上下文问题，没搞明白 */}
                        {/* 浪费了好多时间啊...有谁能解惑求告知 */}
                        <div style={{ display: step == 'attribute' ? 'block' : 'none' }}>
                            {this.renderAttributeFilter()}
                            {this.renderAttributeTable()}
                        </div>
                        <div style={{ display: step == 'option' ? 'block' : 'none' }}>
                            {this.renderOptionFilter()}
                            {this.renderOptionTable()}
                        </div>
                    </div>
                </AntModal>
            </Fragment>
        );
    }
}
